
export const contactData = {
  phone: "5516981695413",
  phoneFormatted: "(16) 98169-5413",
  email: "contato@daneluci.com.br",
  address: "R. dos Pracinhas, 1992 - Franca, SP",
  instagramBrand: "https://www.instagram.com/daneluciperfomance/",
  instagramDudu: "https://www.instagram.com/dududaneluci92/",
  instagramGabi: "https://www.instagram.com/gabivergilio/",
  whatsappLink: (message?: string) => {
    const baseUrl = "https://wa.me/5516981695413";
    return message ? `${baseUrl}?text=${encodeURIComponent(message)}` : baseUrl;
  }
};
